export const supportContact = {
  email: "employerportalsupport@unum.co.uk",
  phoneNumber: "0345 850 9885",
  contactTimes: "(Monday-Friday, 9am-5pm GMT, excluding Bank Holidays)",
  subject: "Employer portal enquiry",
};

export const claimsTeamContact = {
  email: "ClaimsUK@unum.co.uk",
  phoneNumber: "0345 600 6761",
};

export const absenceManagementContact = {
  phoneNumber: "0345 600 6765",
  email: "RehabUK@unum.co.uk",
};

export const featureFlags = {
  phoenixRehab: "232554_PheonixRehab",
  reportingRestriction: "237286_ReportingRestriction",
  tnc: "239308_KontentAITermsAndCondtions"
};